import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c58176"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "__global-nav-app",
  class: "body"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "mobile-nav-menu",
  class: "d-lg-none"
}
const _hoisted_6 = {
  id: "mobile-brand-logo",
  class: "d-lg-none",
  href: "https://barbri.com"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "d-none d-lg-block" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sign In ")
const _hoisted_12 = { class: "d-block d-lg-none" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileNavMenu = _resolveComponent("MobileNavMenu")!
  const _component_NavigationBar = _resolveComponent("NavigationBar")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MobileUserMenu = _resolveComponent("MobileUserMenu")!
  const _component_NavTopDropdown = _resolveComponent("NavTopDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "banner-span",
      class: "d-flex align-items-center h-100 mx-auto",
      style: _normalizeStyle('max-width: ' + $props.bannerWidth)
    }, [
      _createElementVNode("a", {
        href: "https://www.barbri.com/",
        class: "d-none d-lg-inline",
        onFocusin: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeMenu && $setup.closeMenu(...args)))
      }, [
        _createElementVNode("img", {
          id: "barbri-logo",
          class: "align-top",
          src: require('~/img/barbri_logo_black.svg'),
          alt: "open about barbri"
        }, null, 8, _hoisted_2)
      ], 32),
      _createElementVNode("button", {
        id: "mobile-nav-button",
        class: "d-inline-block d-lg-none",
        "aria-expanded": $setup.showMenu,
        "aria-controls": "mobile-nav-menu",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleShowMenu && $setup.toggleShowMenu(...args)))
      }, [
        _createElementVNode("img", {
          id: "mobile-menu-icon",
          class: "ms-1 ms-lg-3 align-top",
          src: require('~/img/menu_icon.svg'),
          alt: "open barbri menu"
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_MobileNavMenu, {
          "is-open": $setup.showMenu,
          onClose: $setup.closeMenu
        }, null, 8, ["is-open", "onClose"])
      ]),
      ($props.showMenus)
        ? (_openBlock(), _createBlock(_component_NavigationBar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("a", _hoisted_6, [
        _createElementVNode("img", {
          src: require('~/img/barbri_logo_black.svg'),
          alt: ""
        }, null, 8, _hoisted_7)
      ]),
      ($setup.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_MobileUserMenu, {
            key: 1,
            modelValue: $setup.showDropdown,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showDropdown) = $event)),
            "first-name": $props.firstName,
            "last-name": $props.lastName,
            class: "ms-auto"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.dropOptions, (item, index) => {
                return (_openBlock(), _createBlock(_component_MenuItem, {
                  key: index,
                  url: item.url,
                  "img-path": item.imgPath,
                  label: item.label
                }, null, 8, ["url", "img-path", "label"]))
              }), 128)),
              _createVNode(_component_MenuItem, {
                url: $props.logOutUrl,
                "img-path": _ctx.sharedLogout,
                label: "Log out"
              }, null, 8, ["url", "img-path"])
            ]),
            _: 1
          }, 8, ["modelValue", "first-name", "last-name"]))
        : _createCommentVNode("", true),
      ($setup.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_NavTopDropdown, {
            key: 2,
            modelValue: $setup.showDropdown,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.showDropdown) = $event)),
            "first-name": $props.firstName,
            "last-name": $props.lastName,
            class: "ms-auto",
            onFocusin: $setup.closeMenu
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.dropOptions, (item, index) => {
                return (_openBlock(), _createBlock(_component_MenuItem, {
                  key: index,
                  url: item.url,
                  "img-path": item.imgPath,
                  label: item.label
                }, null, 8, ["url", "img-path", "label"]))
              }), 128)),
              _createVNode(_component_MenuItem, {
                url: $props.logOutUrl,
                "img-path": _ctx.sharedLogout,
                label: "Log out"
              }, null, 8, ["url", "img-path"])
            ]),
            _: 1
          }, 8, ["modelValue", "first-name", "last-name", "onFocusin"]))
        : (_openBlock(), _createElementBlock("a", {
            key: 3,
            id: "sign-in",
            class: "pe-4 text-dark ms-auto text-decoration-none",
            href: $props.signInUrl,
            onFocusin: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.closeMenu && $setup.closeMenu(...args)))
          }, [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("img", {
                id: "person-svg",
                src: require('~/img/User_Icon.svg'),
                alt: ""
              }, null, 8, _hoisted_10),
              _hoisted_11
            ]),
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("img", {
                id: "person-svg",
                src: require('~/img/account_circle.svg'),
                alt: ""
              }, null, 8, _hoisted_13)
            ])
          ], 40, _hoisted_8))
    ], 4)
  ]))
}